export default "__VITE_ASSET__34586fe6__"